import { render, staticRenderFns } from "./RenameRichTextDocModal.vue?vue&type=template&id=4e0ebce0&scoped=true&"
import script from "./RenameRichTextDocModal.vue?vue&type=script&lang=ts&"
export * from "./RenameRichTextDocModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0ebce0",
  null
  
)

export default component.exports